import GeneralModal from '../../../components/GeneralModal/GeneralModal'
import TextInput from '../../../components/TextInput/TextInput'
import { useState } from 'react'
import useDebounce from '../../../utils/hooks/useDebounce'
import { usePortfolioSlugCheckMutation } from '../../../api/api'
import LoadingSpinner from '../../../components/LoadingSpinner/LoadingSpinner'
import SlugTextInput from '../../../components/TextInput/SlugTextInput'

const PortfolioEditSlugModal = ({
  portfolioId,
  initialValues,
  isOpen,
  onRequestClose,
  onSubmit,
}) => {
  const [values, setValues] = useState({ ...initialValues })
  const [isOutOfDate, setIsOutOfDate] = useState(false)
  const debouncedCheckSlug = useDebounce(500)
  const [fetchCheckSlug, { isLoading, data }] = usePortfolioSlugCheckMutation()
  function handleSlugChange(evt) {
    const value = evt.target.value
      .toLowerCase()
      .replace(/ /g, '-')
      .replace(/[^A-Za-z0-9_-]+/g, '')
    setValues({ ...values, slug: value })
    setIsOutOfDate(true)
    if (value) {
      if (domainCheck(value)) {
        debouncedCheckSlug(() => {
          fetchCheckSlug({ id: portfolioId, slug: value }).then(() =>
            setIsOutOfDate(false),
          )
        })
      }
    }
  }

  function domainCheck(slug) {
    try {
      new URL(`https://sharefol.io/${slug}`)
      return true
    } catch (err) {
      return false
    }
  }

  function canSubmit() {
    return (
      !isOutOfDate && !isLoading && data?.isValid && domainCheck(values?.slug)
    )
  }

  function handleSubmit() {
    if (canSubmit()) {
      onSubmit(values)
    }
  }

  return (
    <GeneralModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      title="Edit Link"
      buttons={[
        {
          className: 'button bg-pink',
          text: 'Save',
          disabled: !canSubmit(),
          onClick: handleSubmit,
        },
      ]}
    >
      <div className="relative">
        <SlugTextInput
          value={values.slug}
          onChange={handleSlugChange}
          onEnter={handleSubmit}
        />
        {isLoading ? (
          <div className="absolute right-[10px] top-[31px]">
            <LoadingSpinner size="small" />
          </div>
        ) : null}
      </div>
      {data?.isValid === false ? (
        <div className="p-4 bg-pink-dark rounded border border-pink-error my-4">
          That link is already in use by another one of your portfolios. Please
          choose another one.
        </div>
      ) : null}

      <div className="text-sm text-white-dark mt-2">
        Please Note: if you change your link to be more easily guessed, consider
        adding a password to your portfolio.
      </div>
    </GeneralModal>
  )
}

export default PortfolioEditSlugModal
